import getSyncTrackLines, {GetSyncTrackLinesOptions} from './getSyncTrackLines';
import {SyncPromise} from '../react/useGetSyncPromise';

export default function getSyncTrackMultiLine(
    options: GetSyncTrackLinesOptions
): SyncPromise<TrackMultiLine> {

    const [lines, error, isLoaded] = getSyncTrackLines(options);
    return [lines && {
        type: 'Feature',
        properties: options.track.properties,
        geometry: {
            type: 'MultiLineString',
            coordinates: lines.map(line => line.geometry.coordinates)
        }
    }, error, isLoaded];
}
